<template>
  <section id="HomeHeadline">
    <div class="container">
      <div
        class="dropdown"
        style="display: flex; justify-content: flex-end;position: absolute;right: 2rem;top: 2rem;"
      >
        <button
          class="btn btn-secondary dropdown-toggle"
          style="background: transparent; border: transparent;"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          EN
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="https://www.meta.com.br/dxi/">PT-BR</a>
          <a class="dropdown-item" href="https://www.metait.ca/dxi/">EN</a>
        </div>
      </div>

      <div class="logo-meta">
        <a href="#" style="cursor:initial;"
          ><img
            width="209"
            height="77"
            src="@/assets/img/logo-meta.png"
            alt="Logo"
            class="desk"
          />
          <img
            width="125"
            height="46"
            src="@/assets/img/logo_white.png"
            alt="Logo"
            class="mob"
          />
        </a>
      </div>

      <div class="home-text-a">
        <img src="@/assets/img/home-image.png" alt="" class="desk" />
        <img src="@/assets/img/meta-dxi-mob.png" alt="" class="mob" />
        <div class="home-text-b">
          <p>
            Building the Digital Transformation Index of businesses
          </p>
        </div>
      </div>

      <div class="mob mob-arrows">
        <a href="#HomeForm">
          <img src="@/assets/img/mob-arrows.png" alt="" @click="startNav()" />
        </a>
      </div>

      <home-form class="desk" />

      <div class="home-text-c desk">
        <img src="@/assets/img/home05.png" alt="" />
      </div>
    </div>
  </section>

  <home-form class="mob home-form-mob" />
</template>
<script>
import HomeForm from "./HomeForm.vue";
export default {
  name: "HomeHealine",

  components: { HomeForm },
  data() {
    return {
      one: "205",
      two: "50",
      three: "16",
    };
  },
  methods: {
    findPos(obj) {
      var curtop = 0;
      if (obj.offsetParent) {
        do {
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));
        return [curtop];
      }
    },
    startNav() {
      window.scroll(
        0,
        this.findPos(document.getElementsByClassName("home-form-mob")[0])
      );
    },
  },
};
</script>
<style lang="scss"></style>
